import { ReactNode, useState } from "react";

interface ButtonCreaNuovoProps {
    onClick: () => void;
    title: string;
    icon: ReactNode;
}

export default function ButtonCreaNuovo({ onClick, title, icon }: ButtonCreaNuovoProps) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <span
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={`mini-card text-start p-2 ${isHovered ? 'bg-secondary border-secondary' : 'bg-white border-secondary'}`}
            style={{ borderRadius: '16px', width: 200 }}
        >
            <div>{icon}</div>
            <h4 style={{ marginTop: "8px" }}>{title}</h4>
        </span>
    );
}
